
import { defineComponent, onMounted, ref, watch } from 'vue-demi';
import useVideoState from '../videoHooks';
import { BytedIconDelete } from '@byte-design/vue-icons';
import { MaterialSource, videoStage } from '@/const/media';
import VideoPlayer from '@/pages/creative/video/video-player-sm.vue';

const name = 'video-info';
export default defineComponent({
  name,
  components: {
    VideoPlayer,
    BytedIconDelete
  },
  setup(props, { emit }) {
    const src = ref('');
    const post = ref('');
    const fileName = ref('');
    const { info, stage, videoSource, verticalVideo, getLabelForUpload, getLabelForTikTokVideo, onDelete, onDeleteForGenerateVideo } = useVideoState(emit);
    const updateInfos = (infos): void => {
      src.value = infos.src;
      post.value = infos.post;
      fileName.value = infos.fileName;
    };
    watch(stage, () => {
      if (stage.value === videoStage.FINISH) {
        const infos = videoSource.value !== MaterialSource.TIKTOK_VIDEO ? getLabelForUpload() : getLabelForTikTokVideo();
        updateInfos(infos);
      }
    });
    onMounted(() => {
      if (stage.value !== videoStage.FINISH) {
        return;
      }
      const infos = videoSource.value !== MaterialSource.TIKTOK_VIDEO ? getLabelForUpload() : getLabelForTikTokVideo();
      updateInfos(infos);
    });
    return {
      src,
      post,
      name,
      info,
      stage,
      onDelete,
      fileName,
      verticalVideo,
      onDeleteForGenerateVideo,
    };
  }
});
